module.exports = __webpack_public_path__ + "img/1f28e40.svg";